import { Expose } from 'class-transformer';

export class ViewVariantProductOptionValueDto {
  @Expose() id: string;
  @Expose() value: string;
}
